module.exports = __webpack_public_path__ + "static/media/double-arrow-up.5be3e9f3.svg";